import React, { useState, useEffect } from "react";
import CalendarView from "./workingHours/CalendarView";

const WorkingHours: React.FC<{ teamMemberData: any; locationId: number }> = ({
  teamMemberData,
  locationId,
}) => {
  return (
    <div className="h-[400px] bg-[#EEF0FF] p-4">
      <CalendarView locationId={locationId} teamMemberData={teamMemberData} />
    </div>
  );
};

export default WorkingHours;
